import { ContentSavePlusOutlineIcon } from './ContentSavePlusOutlineIcon';

/**
 * author: Hans Böhm
 * id 56051C42-5524-47EE-B8A9-66AE8CFC43C2
 * name content-save-plus-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-plus-outline.svg
 * tags
 */
export const ContentSaveAddOutlineIcon = ContentSavePlusOutlineIcon;
export default ContentSaveAddOutlineIcon